import React from 'react';
import StableMuiDialog from '../../../common/StableMuiDialog.js';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

const PhotoDeleteConfirmDialog = ({ open, onClose, onConfirm, dialogProps }) => (
  <StableMuiDialog open={open} onClose={onClose} maxWidth="xs" fullWidth {...dialogProps}>
    <DialogTitle>Delete Photo</DialogTitle>
    <DialogContent>
      Are you sure you want to delete this photo? This action cannot be undone.
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="inherit">Cancel</Button>
      <Button onClick={onConfirm} variant="contained" color="error">Delete</Button>
    </DialogActions>
  </StableMuiDialog>
);

export default PhotoDeleteConfirmDialog;
